module.exports = "<div class=\"container\">\n\n  <div class=\"row\">\n\n    <div class=\"col-lg-12 text-center v-center\">\n\n      <h1 id=\"homeHeading\">Download the application</h1>\n      <p class=\"lead\">Scan de code below to start monitoring</p>\n      <br><br>\n      <div >\n         <img class=\"downImg\" alt=\"Scan de code start monitoring\" src=\"../../assets/img/static_qr_code_without_logo.jpg\">\n      </div>\n      <br><br>\n\n    </div>\n\n  </div> <!-- /row -->\n\n  <br>\n\n  <floow-us></floow-us>\n\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/download/download.component.html
// module id = ./src/app/download/download.component.html
// module chunks = main